import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"

const Introduction = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  if (module.hideSection === "no") {
    return (
      <motion.section
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className={`intro-content py-80 pb-50 lgscreen:py-50${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
        >
          <div className="w-full max-w-[1100px] lgscreen:px-20 mx-auto text-center">
            {module?.preHeading && (
              <div className="preheading mb-5 lgscreen:mb-15">
                <motion.div variants={animFade} className="title-green">
                  <span className="font-ositalic text-16">
                    {module.preHeading}
                  </span>
                </motion.div>
              </div>
            )}

            {module?.heading && (
              <motion.h2 variants={animFade}>{module.heading}</motion.h2>
            )}
            {module?.description && (
              <motion.div
                variants={animFade}
                className="content pt-10 lgscreen:pt-20"
              >
                {parse(module.description)}
              </motion.div>
            )}
            {module?.button && (
              <motion.div variants={animFade} className="mt-40 lgscreen:mt-20">
                <Link
                  to={module.button.url}
                  className="btn btn-border"
                  target={module.button.target}
                >
                  {module.button.title}
                </Link>
              </motion.div>
            )}
          </div>
          <div className="relative mt-60 lgscreen:mt-30 px-30">
            {module.micrositeLogos.length > 0 && (
              <motion.div variants={animFade}>
                <Swiper
                  spaceBetween={30}
                  loop={true}
                  slidesPerView={"8"}
                  speed={1000}
                  autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                  }}
                  pagination={{
                    clickable: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    450: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                    641: {
                      slidesPerView: 6,
                    },
                    1024: {
                      slidesPerView: 8,
                    },
                  }}
                  modules={[Autoplay, Navigation]}
                >
                  {module.micrositeLogos.map((item, i) => (
                    <SwiperSlide key={i}>
                      <Link to={item.link.url} target={item.link.target}>
                        <div className="img relative">
                          {item?.logo && (
                            <img
                              src={item.logo.mediaItemUrl}
                              width={1000}
                              height={1000}
                              alt={item.logo.altText}
                              loading="lazy"
                            />
                          )}
                        </div>
                      </Link>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </motion.div>
            )}
          </div>
        </motion.div>
      </motion.section>
    )
  }
  return null
}

export default Introduction
export const PageIntroductionFragment = graphql`
  fragment PageIntroductionFragment on WpPage_Pagecontent_PageContent_Introduction {
    extraId
    extraClass
    hideSection
    preHeading
    heading
    description
    button {
      target
      title
      url
    }
    micrositeLogos {
      logo {
        altText
        mediaItemUrl
      }
      link {
        target
        title
        url
      }
    }
  }
`
